import { createContext, useContext, useState, useEffect } from 'react';

const PageTitleContext = createContext(null);

export const PageTitleProvider = ({ children }) => {
  const [pageHeader, setPageHeader] = useState(null); // { title, icon }
  return (
    <PageTitleContext.Provider value={{ pageHeader, setPageHeader }}>
      {children}
    </PageTitleContext.Provider>
  );
};

export const usePageTitle = () => useContext(PageTitleContext);

/**
 * Register a title (optional material-symbol icon + subtitle + badge) for the TopNavbar
 * while this component is mounted. Cleared automatically on unmount.
 */
export const useRegisterPageHeader = (title, icon, subtitle, badge) => {
  const ctx = usePageTitle();
  const setPageHeader = ctx?.setPageHeader;
  useEffect(() => {
    if (!setPageHeader) return undefined;
    setPageHeader({ title, icon, subtitle, badge });
    return () => setPageHeader(null);
  }, [setPageHeader, title, icon, subtitle, badge]);
};

export default PageTitleContext;
